import { render, staticRenderFns } from "./Detalhamento.vue?vue&type=template&id=2f282cbb&scoped=true&"
import script from "./Detalhamento.vue?vue&type=script&lang=js&"
export * from "./Detalhamento.vue?vue&type=script&lang=js&"
import style0 from "./Detalhamento.vue?vue&type=style&index=0&id=2f282cbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f282cbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VContainer,VDialog,VIcon,VLayout})
